import React from "react";
import PropTypes from 'prop-types';
import { StyledTypography } from "./styled";

const Typography = ({ children, as, font, color, customStyle, align, dangerouslySetInnerHTML }) => {
  return (
    <StyledTypography
      as={as}
      font={font}
      color={color}
      customStyle={customStyle}
      align={align}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    >
      {children}
    </StyledTypography>
  );
};  

Typography.propTypes = {
  children: PropTypes.node,
  as: PropTypes.string,
  font: PropTypes.any,
  color: PropTypes.string,
  customStyle: PropTypes.array,
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
};

Typography.defaultProps = {
  align: 'inherit'
};

export default React.memo(Typography);
